// Stripe product & price IDs
export const STRIPE_CONFIG = {
  monthly: {
    product_id: "prod_UAXHQyENmORF8Y",
    price_id: "price_1TCCCqRPYJNZEcsqxGeIsGpz",
    label: "Monthly",
    amount: "$6.99/month",
  },
  annual: {
    product_id: "prod_UAXI0gm8eH1U55",
    price_id: "price_1TCCE2RPYJNZEcsqVDOSU9vm",
    label: "Annual",
    amount: "$49.99/year",
  },
  founding: {
    product_id: "prod_UAXJVT2BJZI4EJ",
    price_id: "price_1TCCEdRPYJNZEcsqEuOtHwuh",
    label: "Founding Member",
    amount: "$3.99/month",
    cap: 200,
  },
  // Legacy single coach plan (kept for backward compat with existing subscribers)
  coach: {
    product_id: "prod_UDpIXTaZK4CCEu",
    price_id: "price_1TFNdTRPYJNZEcsqJZSR9GcU",
    label: "Coach Pro",
    amount: "$9.99/month",
  },
  // The only paid coach plan.
  coach_pro: {
    product_id: "prod_UDpIXTaZK4CCEu",
    price_id: "price_1TFNdTRPYJNZEcsqJZSR9GcU",
    label: "Coach Pro",
    amount: "$9.99/month",
  },
} as const;

export type CoachTier = 'free' | 'pro';

export const COACH_TIER_LIMITS = {
  free: { teams: 1, playlists: 1, assignments: 6, analytics: false },
  pro: { teams: -1, playlists: -1, assignments: -1, analytics: true }, // -1 = unlimited
} as const;

/** Map Stripe product IDs to coach tiers */
export function resolveCoachTier(productId: string | null): CoachTier {
  if (!productId) return 'free';
  if (productId === STRIPE_CONFIG.coach_pro.product_id) return 'pro';
  if (productId === STRIPE_CONFIG.coach.product_id) return 'pro';
  return 'free';
}
